// Separate origin + auth headers → own axios call + method wrappers
// (mirrors utils/api.js), not the shared api layer.
import axios from 'axios'

import {
  AI_BRAIN_DEV_ORIGIN,
  AI_BRAIN_ORIGIN_PATH,
} from '../constants/aiAgents'
import { EMPTY_OBJECT } from '../constants/common'
import { LOCAL_STORAGE_NAME_JWT_REFRESH } from '../constants/storage'
import { getJWT, persistRefreshedJWT } from '../hooks'
import { isAIBrainTokenExpiredError } from '../utils/aiAgents'
import { getOrigin } from '../utils/api'
import { isDevelopmentEnvironment } from '../utils/common'
import { getStorageItem } from '../utils/storage'

function getBrainOrigin() {
  return isDevelopmentEnvironment()
    ? AI_BRAIN_DEV_ORIGIN
    : `${getOrigin()}${AI_BRAIN_ORIGIN_PATH}`
}

function getBrainHeaders(conversationId) {
  return {
    'Content-Type': 'application/json',
    ...(conversationId
      ? { 'x-idwell-conversation-id': conversationId }
      : undefined),
    'x-openwebui-user-api-key': getStorageItem(LOCAL_STORAGE_NAME_JWT_REFRESH),
  }
}

function callBrainApi({ conversationId, data, method, options, url }) {
  function sendRequest() {
    return axios({
      ...options,
      ...(data ? { data } : {}),
      baseURL: getBrainOrigin(),
      headers: getBrainHeaders(conversationId),
      method,
      url,
    })
  }

  return sendRequest().catch(reason => {
    if (!isAIBrainTokenExpiredError(reason)) {
      throw reason
    }

    return getJWT().then(({ data: refreshedData }) => {
      persistRefreshedJWT(refreshedData)

      return sendRequest()
    })
  })
}

export function postBrainApi(config) {
  return callBrainApi({ ...config, method: 'post' })
}

export function deleteBrainApi(config) {
  return callBrainApi({ ...config, method: 'delete' })
}

// Brain stores the question — create the chat first, never POST to /messages/.
export function requestAICompletion({
  conversationId,
  messages,
  options,
} = EMPTY_OBJECT) {
  return postBrainApi({
    conversationId,
    data: { messages },
    options,
    url: '/v1/chat/completions',
  })
}

// Only this cancels the turn; dropping our connection doesn't
export function stopAITurn({ conversationId, options } = EMPTY_OBJECT) {
  return deleteBrainApi({
    options,
    url: `/v1/conversations/${conversationId}/turn`,
  })
}
